import Modulo4 from "../pages/modulo4/Modulo4";
import Modulo4Conclusion from "../pages/modulo4/Modulo4Conclusion";
import Modulo4U1A1 from "../pages/modulo4/unidad1/Actividad1";
import Modulo4U1A2 from "../pages/modulo4/unidad1/Actividad2";
import Modulo4U1A3 from "../pages/modulo4/unidad1/Actividad3";
import Modulo4U1A4 from "../pages/modulo4/unidad1/Actividad4";
import Modulo4U1A5 from "../pages/modulo4/unidad1/Actividad5";
import Modulo4U1A6 from "../pages/modulo4/unidad1/Actividad6";
import Modulo4U1A7 from "../pages/modulo4/unidad1/Actividad7";
import Modulo4U1A8 from "../pages/modulo4/unidad1/Actividad8";

export const modulo4 = {
  title: "Mi país en el mundo",
  grade: { name: "Nivel 1", url: "/nivel-1" },
  module: "Módulo 4",
  year: 'Primer grado',
  component: <Modulo4 />,
  conclusion: <Modulo4Conclusion />,
  tags: [
    { name: "nacionalidad", url: "nacionalidad" },
    { name: "identidad", url: "identidad" },
    { name: "Perú en el mundo", url: "peru-en-el-mundo" },
  ],
  skills: [
    { name: "Construye su identidad", url: "/construye-su-identidad" },
    {
      name: "Convive y participa democráticamente",
      url: "/convive-y-participa-democraticamente",
    },
    {
      name: "Gestiona responsablemente el espacio y el ambiente",
      url: "/gestiona-responsablemente-el-espacio-y-el-ambiente",
    },
  ],
  url: "mi-pais-en-el-mundo",
  color: "green",
  content: [
    {
      name: "Unidad 1",
      path: "unidad-1",
      activities: [
        {
          name: "Actividad 1",
          path: "actividad-1",
          component: <Modulo4U1A1 />,
        },
        {
          name: "Actividad 2",
          path: "actividad-2",
          component: <Modulo4U1A2 />,
        },
        {
          name: "Actividad 3",
          path: "actividad-3",
          component: <Modulo4U1A3 />,
        },
        {
          name: "Actividad 4",
          path: "actividad-4",
          component: <Modulo4U1A4 />,
        },
        {
          name: "Actividad 5",
          path: "actividad-5",
          component: <Modulo4U1A5 />,
        },
        {
          name: "Actividad 6",
          path: "actividad-6",
          component: <Modulo4U1A6 />,
        },
        {
          name: "Actividad 7",
          path: "actividad-7",
          component: <Modulo4U1A7 />,
        },
        {
          name: "Actividad 8",
          path: "actividad-8",
          component: <Modulo4U1A8 />,
        },
      ],
    },
  ],
};
